import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import useAxios from '../utils/useAxios';
import { FaUser, FaHistory, FaSearch } from 'react-icons/fa';
import { useSidebar } from '../context/SidebarContext';

const EmployeList = () => {
  const [employes, setEmployes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const axiosInstance = useAxios();
  const { sidebarVisible } = useSidebar();

  useEffect(() => {
    const fetchEmployes = async () => {
      try {
        const response = await axiosInstance.get('/pointage/employes-presence/');
        setEmployes(response.data);
      } catch (err) {
        console.error("Erreur lors de la récupération des employés", err);
      } finally {
        setLoading(false);
      }
    };

    fetchEmployes();
  }, []);

  const filteredEmployes = employes.filter(employe => 
    employe.first_name.toLowerCase().includes(search.toLowerCase()) ||
    employe.last_name.toLowerCase().includes(search.toLowerCase()) ||
    employe.matricule.toLowerCase().includes(search.toLowerCase())
  );

  const styles = {
    container: {
      marginLeft: sidebarVisible ? 250 : 0,
      padding: '30px',
      minHeight: '100vh',
      backgroundColor: '#f4f6f9',
      fontFamily: 'Segoe UI, sans-serif',
    },
    header: {
      color: '#1B019B',
      fontWeight: '600',
      fontSize: '1.5rem',
      marginBottom: '20px',
    },
    card: {
      backgroundColor: 'white',
      borderRadius: '10px',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      padding: '20px',
      marginBottom: '20px',
    },
    searchBar: {
      width: '100%',
      padding: '10px 15px',
      borderRadius: '20px',
      border: '1px solid #ddd',
      marginBottom: '20px',
      fontSize: '1rem',
    },
    employeCard: {
      display: 'flex',
      alignItems: 'center',
      padding: '15px',
      borderBottom: '1px solid #eee',
      transition: 'all 0.3s ease',
      ':hover': {
        backgroundColor: '#f8f9fa',
      },
    },
    employeImage: {
      width: '50px',
      height: '50px',
      borderRadius: '50%',
      marginRight: '15px',
      objectFit: 'cover',
    },
    employeInfo: {
      flex: 1,
    },
    employeName: {
      fontWeight: '600',
      marginBottom: '5px',
    },
    employeDetails: {
      color: '#666',
      fontSize: '0.9rem',
    },
    viewButton: {
      backgroundColor: '#1B019B',
      color: 'white',
      border: 'none',
      borderRadius: '20px',
      padding: '8px 15px',
      cursor: 'pointer',
      textDecoration: 'none',
      display: 'inline-block',
    },
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.header}>Liste des Employés</h1>
      
      <div style={styles.card}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
          <FaSearch style={{ marginRight: '10px', color: '#666' }} />
          <input
            type="text"
            placeholder="Rechercher un employé..."
            style={styles.searchBar}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        {loading ? (
          <div>Chargement en cours...</div>
        ) : filteredEmployes.length === 0 ? (
          <div>Aucun employé trouvé</div>
        ) : (
          filteredEmployes.map(employe => (
            <div key={employe.id} style={styles.employeCard}>
              <img 
                src={employe.image || '/default-user.png'} 
                alt={`${employe.first_name} ${employe.last_name}`} 
                style={styles.employeImage}
                onError={(e) => { e.target.src = '/default-user.png' }}
              />
              <div style={styles.employeInfo}>
                <div style={styles.employeName}>
                  {employe.first_name} {employe.last_name}
                </div>
                <div style={styles.employeDetails}>
                  {employe.poste} • {employe.matricule}
                </div>
              </div>
              <Link 
                to={`/employes/${employe.id}`} 
                style={styles.viewButton}
              >
                <FaHistory style={{ marginRight: '5px' }} />
                Voir les présences
              </Link>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default EmployeList;